{
  "errors": {
    "network": "Netzwerkfehler. Bitte überprüfe deine Verbindung und versuche es erneut.",
    "unknown": "Ein Fehler ist aufgetreten. Bitte versuche es erneut.",
    "operationNotSupported": "Operation '{{operation}}' wird nicht unterstützt",
    "http": {
      "400": "Ungültige Anfrage",
      "401": "Nicht autorisiert. Bitte melde dich erneut an.",
      "403": "Zugriff verweigert",
      "404": "Nicht gefunden",
      "409": "Dieser Eintrag existiert bereits",
      "422": "Validierung fehlgeschlagen. Bitte überprüfe deine Eingaben.",
      "500": "Serverfehler. Bitte versuche es später erneut.",
      "503": "Service vorübergehend nicht verfügbar"
    },
    "validation": {
      "required": "Dieses Feld ist erforderlich",
      "invalid": "Ungültiger Wert",
      "minLength": "Zu kurz",
      "maxLength": "Zu lang",
      "duplicate": "Existiert bereits",
      "email": "Ungültige E-Mail-Adresse",
      "password": "Passwort entspricht nicht den Anforderungen",
      "passwordsMismatch": "Passwörter stimmen nicht überein",
      "failed": "Validierung fehlgeschlagen",
      "selectPerson": "Bitte wähle eine Person aus",
      "selectOrgFunction": "Bitte wähle eine Funktion aus",
      "selectSystem": "Bitte wähle ein System aus",
      "selectExternalContact": "Bitte wähle einen externen Kontakt aus",
      "fileRequired": "Bitte wähle eine Datei aus",
      "url": "Ungültige URL"
    },
    "department": {
      "duplicateAbbreviation": "Abteilung mit Abkürzung '{{abbreviation}}' existiert bereits",
      "abbreviationAlreadyInUse": "Abteilungsabkürzung '{{abbreviation}}' wird bereits verwendet",
      "abbreviationDuplicateInData": "Doppelte Abkürzung '{{abbreviation}}' in den Daten gefunden",
      "nameAlreadyInUse": "Abteilungsname '{{name}}' wird bereits verwendet",
      "nameDuplicateInData": "Doppelter Name '{{name}}' in den Daten gefunden",
      "notFound": "Abteilung nicht gefunden",
      "parentNotFound": "Übergeordnete Abteilung nicht gefunden",
      "selfParent": "Eine Abteilung kann nicht ihre eigene übergeordnete Abteilung sein",
      "circularDependency": "Eine Abteilung kann nicht unter eine ihrer eigenen Unterabteilungen verschoben werden",
      "hasSubdepartments": "Abteilung mit Unterabteilungen kann nicht gelöscht werden",
      "hasMembers": "Abteilung mit Personen kann nicht gelöscht werden",
      "noManager": "Die folgenden Abteilungen haben keinen Manager zugewiesen: {{departments}}. Bitte weise Manager zu, bevor du Prozesse erstellst.",
      "alreadyResolved": "Diese Abteilung hat bereits einen Manager"
    },
    "orgFunction": {
      "notFound": "Funktion nicht gefunden",
      "mainRoleInvalidKind": "Die Stelle muss eine Funktion vom Typ Stelle sein",
      "nameDuplicateInData": "Doppelter Name '{{name}}' in den Daten gefunden",
      "nameAmbiguous": "'{{name}}' ist mehrdeutig – es existiert sowohl eine Funktion als auch ein Team mit diesem Namen",
      "alreadyExists": "'{{name}}' existiert bereits und wurde übersprungen"
    },
    "common": {
      "invalidId": "Ungültige ID angegeben"
    },
    "auth": {
      "invalidPassword": "Ungültige E-Mail oder Passwort. Bitte versuche es erneut.",
      "passwordUnchanged": "Dein neues Passwort muss sich von deinem aktuellen Passwort unterscheiden.",
      "userNotFound": "Ungültige E-Mail oder Passwort. Bitte versuche es erneut.",
      "unauthorized": "Nicht autorisiert. Bitte melde dich erneut an.",
      "noMembership": "Du hast noch keinen Zugriff auf einen Arbeitsbereich. Bitte deinen Administrator um eine Einladung.",
      "ssoRequired": "Dieser Arbeitsbereich erfordert Single Sign-On. Fahre mit deiner E-Mail fort, um dich über deine Organisation anzumelden.",
      "notZitadelLinked": "Ihr Konto ist noch nicht mit dem Identitätssystem verknüpft. Melden Sie sich einmal per Single Sign-on an oder kontaktieren Sie Ihren Administrator.",
      "reauthRequired": "Aus Sicherheitsgründen musst du dich erneut anmelden, bevor du deine Anmeldeeinstellungen ändern kannst."
    },
    "sso": {
      "stateExpired": "Deine Anmeldesitzung ist abgelaufen. Bitte versuche es erneut.",
      "exchangeFailed": "Die Anmeldung konnte nicht abgeschlossen werden. Bitte versuche es erneut.",
      "transactionInvalid": "Diese Anmeldung kann nur in dem Browser abgeschlossen werden, in dem du sie gestartet hast. Bitte melde dich erneut an.",
      "emailMismatch": "Das angemeldete Konto stimmt nicht mit der eingegebenen E-Mail überein. Bitte versuche es erneut.",
      "emailUnverified": "Deine E-Mail-Adresse ist nicht verifiziert. Bitte verifiziere sie bei deinem Identitätsanbieter und versuche es erneut."
    },
    "user": {
      "notFound": "Benutzer nicht gefunden",
      "alreadyExists": "Ein Konto mit dieser E-Mail-Adresse ({{email}}) existiert bereits.",
      "duplicateEmail": "Benutzer mit E-Mail '{{email}}' existiert bereits in dieser Organisation",
      "emailDuplicateInData": "Doppelte E-Mail-Adresse '{{email}}' in den Daten gefunden",
      "invalidEmail": "Ungültige E-Mail-Adresse",
      "inactive": "Benutzerkonto ist inaktiv",
      "suspended": "Dein Konto wurde gesperrt. Bitte wende dich an deinen Administrator.",
      "alreadySuspended": "Benutzerkonto ist bereits gesperrt",
      "alreadyActive": "Benutzerkonto ist bereits aktiv",
      "invalidStatus": "Ungültiger Benutzerstatus",
      "alreadyHasCredentials": "Diese Person hat bereits Anmeldedaten und kann sich direkt anmelden – ein Aktivierungslink wird nicht benötigt.",
      "emailChangeNotAllowed": "Die E-Mail-Adresse dieser Person kann nicht geändert werden, da sie ihre Anmelde-Identität ist. Wende dich an den Support, falls eine Änderung nötig ist.",
      "externalMemberNoDepartment": "Externe Personen können keiner Abteilung zugewiesen werden",
      "externalMemberNoTeam": "Externe Personen können keiner Funktion zugewiesen werden",
      "externalMemberRequiresRole": "Externe Mitarbeiter müssen mind. einen Benutzertypus erhalten",
      "userTypesTenantTypeMismatch": "Diese Rollen passen nicht zum Typ dieser Organisation. Partner-Organisationen vergeben Partner-Rollen, Kunden- und Demo-Organisationen die Kundenrollen.",
      "memberIsTeamLead": "Kann nicht als extern klassifiziert werden: Person ist derzeit Funktionsleitung. Entferne zuerst die Funktionsleitung.",
      "emailNotFound": "Kein Mitarbeiter mit der E-Mail '{{email}}' gefunden"
    },
    "partner": {
      "tenantRequired": "Dieser Bereich steht nur Partner-Organisationen zur Verfügung.",
      "adminRequired": "Diese Aktion ist Partner-Admins vorbehalten.",
      "memberRequiresRole": "Mitglieder einer Partner-Organisation brauchen eine Partner-Rolle.",
      "memberMustBeInternal": "Mitglieder einer Partner-Organisation sind interne Mitarbeitende der Partnerfirma.",
      "hubspotNotLinked": "Dieses Partner-Konto ist noch mit keinem HubSpot-Unternehmen verknüpft. Diese Verknüpfung muss ein Bliks-Administrator herstellen.",
      "salesNotActivated": "Dieses Mitglied ist nicht für den Vertrieb freigeschaltet, dem Lead fehlt damit der Akquisiteur. Ein Partner-Admin kann die Freischaltung in der Benutzerverwaltung vornehmen.",
      "salesAlreadyActivated": "Dieses Mitglied ist bereits für den Vertrieb freigeschaltet.",
      "memberNotActive": "Dieses Mitglied hat seine Einladung noch nicht angenommen. Die Freischaltung für den Vertrieb ist erst nach der ersten Anmeldung möglich.",
      "contactAlreadyLinked": "Dieser HubSpot-Kontakt ist bereits mit einem anderen Mitglied verknüpft.",
      "memberNoEmail": "Für die Verknüpfung mit einem HubSpot-Kontakt wird eine E-Mail-Adresse benötigt.",
      "contactNotAdoptable": "Dieser HubSpot-Kontakt gehört zu einem anderen Partner-Unternehmen und kann hier nicht hinzugefügt werden.",
      "materialNotFound": "Dieses Material gibt es nicht mehr.",
      "materialFileNotFound": "Für dieses Material ist keine Datei hinterlegt.",
      "materialUploadInvalid": "Der Upload ist ungültig. Bitte laden Sie die Datei erneut hoch.",
      "newsNotFound": "Diese Neuigkeit gibt es nicht mehr.",
      "newsImageInvalid": "Das Bild ist ungültig. Bitte laden Sie es erneut hoch."
    },
    "role": {
      "selfRemovalForbidden": "Du kannst dir deine eigene Rolle nicht entziehen – damit würdest du den Zugang verlieren, über den du es rückgängig machen könntest. Bitte einen anderen Admin um diese Änderung.",
      "lastHolderForbidden": "Das ist der letzte aktive Admin. Danach könnte niemand mehr die Benutzer dieser Organisation verwalten."
    },
    "recording": {
      "invalidStatusForAction": "Diese Aktion ist im aktuellen Status der Aufzeichnung nicht erlaubt",
      "nameOrDescriptionRequired": "Zum Abschließen der Aufzeichnung sind sowohl ein Name als auch eine Beschreibung erforderlich",
      "userNotRecordingStep": "Du nimmst diesen Schritt nicht auf",
      "nudgeTargetNotActive": "Diese Person kann keine Erinnerungen erhalten, da ihr Konto nicht aktiv ist",
      "decisionRuleNotFound": "Entscheidungsregel nicht gefunden",
      "decisionHasNoRules": "Entscheidung hat keine definierten Regeln"
    },
    "process": {
      "notFound": "Prozess nicht gefunden",
      "duplicateName": "Prozess mit Name '{{name}}' existiert bereits",
      "invalidOperation": "Dieser Vorgang ist im aktuellen Status nicht erlaubt"
    },
    "processEvent": {
      "notFound": "Ereignis nicht gefunden",
      "startRequired": "Ein Prozess braucht ein Startereignis — es kann nicht entfernt oder umgewandelt werden"
    },
    "processChain": {
      "notFound": "Prozesskette nicht gefunden",
      "circularDependency": "Zirkuläre Abhängigkeit zwischen Prozessketten kann nicht erstellt werden",
      "selfParent": "Eine Prozesskette kann nicht ihr eigenes Elternelement sein",
      "typeConflict": "Eine Kette kann nicht gleichzeitig Unterketten und Prozesse enthalten."
    },
    "processConnection": {
      "notFound": "Prozessverbindung nicht gefunden"
    },
    "processStep": {
      "notFound": "Prozessschritt nicht gefunden"
    },
    "processDraft": {
      "notFound": "Für diesen Prozess existiert kein Entwurf.",
      "alreadyExists": "Für diesen Prozess existiert bereits ein Entwurf.",
      "publishContentValidation": "Einige Schritte enthalten keine erforderlichen Inhalte.",
      "publishGraphValidation": "Einige Schritte sind nicht verbunden.",
      "publishConflict": "Der veröffentlichte Prozess wurde während der Bearbeitung geändert.",
      "stepNotFound": "Entwurfs-Schritt nicht gefunden.",
      "edgeNotFound": "Diese Verbindung existiert im Entwurf nicht mehr.",
      "deleteFailed": "Konnte das nicht löschen — bitte versuche es erneut.",
      "deletePartialFailure": "Einige Schritte konnten nicht gelöscht werden — bitte versuche es erneut.",
      "deleteStaleSelection": "Diese Schritte wurden bereits gelöscht.",
      "noteNotFound": "Notiz nicht gefunden.",
      "historyNotFound": "Für diesen Entwurf existiert kein Bearbeitungsverlauf.",
      "insertNotApplicable": "Dieser Schritt kann hier nicht mehr eingefügt werden.",
      "eventInputNotLinkable": "An diesem Eingang kann kein Ereignis angehängt werden.",
      "convertRequiresPreviousOutput": "Eine Aufgabe braucht mindestens ein eingehendes Ergebnis."
    },
    "organization": {
      "notFound": "Organisation nicht gefunden"
    },
    "approval": {
      "notFound": "Freigabe nicht gefunden",
      "notPending": "Diese Freigabe ist nicht mehr offen",
      "notReviewer": "Du bist für diese Freigabe nicht benannt",
      "ownRequest": "Die eigene Anforderung gibt jemand anderes frei",
      "alreadyDecided": "Du hast schon entschieden",
      "reasonRequired": "Bitte einen Grund angeben",
      "overrideNotAllowed": "Die Regel erlaubt kein Fortfahren ohne Freigabe",
      "notRequester": "Nur wer angefordert hat, kann zurückziehen",
      "notAdmin": "Das dürfen nur Admins des Arbeitsbereichs"
    },
    "task": {
      "notFound": "Aufgabe nicht gefunden",
      "alreadyCompleted": "Aufgabe ist nicht mehr offen",
      "assigneeNotFound": "Die Person für die Aufgabe wurde nicht gefunden"
    },
    "assignment": {
      "notFound": "Zuweisung nicht gefunden",
      "alreadyCompleted": "Zuweisung bereits abgeschlossen",
      "alreadyAcceptedByTeammate": "Diese Aufgabe wurde bereits von einer anderen Person dieser Funktion übernommen. Vielen Dank für dein Engagement.",
      "taskNotDefined": "Zuweisungsaufgabe noch nicht definiert",
      "rulesNotDefined": "Zuweisungsregeln noch nicht definiert",
      "outputNotDefined": "Ausgabe der Zuweisung ist erforderlich",
      "alreadyFinished": "Zuweisung bereits abgeschlossen",
      "reassigneeNotFound": "Neuzuweisungsziel nicht gefunden",
      "notExternalContact": "Dieser Schritt ist keinem externen Kontakt zugewiesen",
      "recordingDelegateNotFound": "Die ausgewählte Person wurde nicht gefunden"
    },
    "merge": {
      "targetNotFound": "Die Ziel-Schrittaufzeichnung wurde nicht gefunden.",
      "targetNotCompleted": "Die Ziel-Schrittaufzeichnung ist noch nicht abgeschlossen.",
      "targetWrongProcess": "Die Ziel-Schrittaufzeichnung gehört zu einem anderen Prozess.",
      "userNotRelated": "Du hast keine Beziehung zu dieser Schrittaufzeichnung.",
      "sameNode": "Ein Schritt kann nicht mit sich selbst zusammengeführt werden."
    },
    "system": {
      "notFound": "System nicht gefunden",
      "nameDuplicateInData": "Doppelter Systemname '{{name}}' in den Daten gefunden",
      "alreadyExists": "System '{{name}}' existiert bereits und wurde übersprungen"
    },
    "artifact": {
      "notFound": "Unterlage nicht gefunden"
    },
    "externalContact": {
      "notFound": "Externer Kontakt nicht gefunden"
    },
    "tenant": {
      "notFound": "Mandant nicht gefunden",
      "expired": "Der Zugang deiner Organisation ist abgelaufen. Bitte kontaktiere deinen Administrator.",
      "cloneFailed": "Mandant konnte nicht dupliziert werden. Die unvollständige Kopie kann zurückgeblieben sein — sie lässt sich in der Mandantenliste verwerfen.",
      "cloneDiscardRefused": "Das Verwerfen der Kopie wurde von einer Sicherheitsprüfung abgelehnt – zum Beispiel weil die Duplizierung doch abgeschlossen wurde und der Mandant nicht mehr zu diesem Auftrag gehört, oder weil sein Prozess noch läuft. Es wurde nichts gelöscht.",
      "cloneInProgress": "Für diesen Mandanten läuft gerade eine Duplizierung. Warte, bis sie abgeschlossen ist, und versuche es dann erneut. Eine laufende Duplizierung lässt sich nicht abbrechen.",
      "slugAlreadyInUse": "Dieser Slug wird bereits von einem anderen Mandanten verwendet. Bitte wähle einen anderen.",
      "typeChangeStrandsMembers": "Der Typ dieser Organisation kann nicht geändert werden, solange {{count}} Mitglieder Rollen des bisherigen Typs haben. Passe zuerst die Rollen an oder leere die Organisation.",
      "hubspotCompanyAlreadyLinked": "Dieses HubSpot-Unternehmen ist bereits mit einem anderen Mandanten verknüpft."
    },
    "appConfig": {
      "notConfigurable": "Diese App hat keine konfigurierbaren Einstellungen.",
      "invalid": "Die Konfiguration passt nicht zu dem, was die App erwartet."
    },
    "seatLimit": {
      "systemAdminsReached": "Das Platzlimit für Systemadministratoren ist erreicht ({{current}} von {{limit}} Plätzen belegt). Sperre oder lösche einen Systemadministrator oder lass das Limit erhöhen.",
      "orgManagersReached": "Das Platzlimit für Organisationsmanager ist erreicht ({{current}} von {{limit}} Plätzen belegt). Sperre oder lösche einen Organisationsmanager oder lass das Limit erhöhen.",
      "membersReached": "Das Platzlimit für Basisnutzer ist erreicht ({{current}} von {{limit}} Plätzen belegt). Sperre oder lösche einen Basisnutzer oder lass das Limit erhöhen.",
      "appSeatsReached": "Diese App hat {{limit}} Plätze, es wurden aber {{requested}} Personen zugewiesen. Weise weniger Personen zu oder lass das Limit erhöhen.",
      "appSeatOrgManagerNotSeatable": "Organisationsmanager erreichen bereits jede App und können keinen Platz belegen. Entferne sie aus der Zuweisung und speichere erneut."
    },
    "seatOverrun": "Deine Organisation hat mehr Nutzer als Plätze. Ein Organisationsmanager oder Systemadministrator muss einen Nutzer sperren oder löschen, bevor Änderungen gespeichert werden können.",
    "initialSetup": {
      "alreadyCompleted": "Die Ersteinrichtung wurde bereits abgeschlossen und kann nicht erneut ausgeführt werden.",
      "prerequisitesMissing": "Bitte richte zuerst Abteilungen und Mitarbeiter ein",
      "notCompleted": "Die Ersteinrichtung deiner Organisation ist noch nicht abgeschlossen. Änderungen sind erst danach möglich.",
      "updateNotAllowed": "Dieser Eintrag kann hier nicht mehr bearbeitet werden. Bitte lade die Seite neu und versuche es erneut.",
      "removalBlocked": "Dieser Eintrag kann nicht gelöscht werden, da andere Einträge darauf verweisen.",
      "incomplete": "Die Ersteinrichtung ist unvollständig. Bitte behebe die offenen Lücken, bevor du abschließt."
    },
    "dataSync": {
      "syncRunNotFound": "Dieser Abgleich existiert nicht mehr.",
      "syncRunInProgress": "Für diese Organisation läuft bereits ein Abgleich. Bitte nach dessen Abschluss erneut versuchen.",
      "syncRunStale": "Dieser Abgleich wurde nicht abgeschlossen. Bitte einen neuen Abgleich starten.",
      "syncRunNotInReview": "Dieser Abgleich kann nicht mehr angewendet werden. Bitte einen neuen Abgleich starten.",
      "selectionInvalid": "Einige ausgewählte Änderungen lassen sich so nicht anwenden. Bitte die Auswahl prüfen und erneut versuchen.",
      "excelInvalidIds": "Die Datei enthält ungültige IDs ({{rows}}). Bitte die IDs aus der heruntergeladenen Datei unverändert übernehmen.",
      "excelDuplicateEmails": "Mehrere Zeilen haben dieselbe E-Mail-Adresse ({{rows}}). Gib jeder Person eine eigene E-Mail-Adresse.",
      "excelDuplicateIds": "Mehrere Zeilen haben dieselbe ID ({{rows}}). Bitte die aktuelle Datei herunterladen und die Änderungen dort eintragen.",
      "excelUnknownIds": "Die Datei enthält IDs, die es in Bliks nicht gibt ({{rows}}). Bitte die aktuelle Datei herunterladen und die Änderungen dort eintragen.",
      "excelMismatchedIds": "Diese Zeilen tragen den Namen eines anderen Eintrags ({{rows}}). Bitte die aktuelle Datei herunterladen und die Änderungen dort eintragen. Soll ein Eintrag den Namen eines Eintrags erhalten, den diese Datei löscht, zuerst die Löschung hochladen.",
      "excelDuplicateNames": "Mehrere neue Zeilen haben denselben Namen ({{rows}}). Gib jedem neuen Eintrag einen eigenen Namen.",
      "excelNameMatchesSeveral": "Diese Zeilen ohne ID tragen einen Namen, den mehrere vorhandene Einträge haben ({{rows}}). Bitte die ID des gemeinten Eintrags eintragen, wie sie in der heruntergeladenen Datei steht.",
      "excelEmptyReferencedSheet": "Das Blatt {{sheet}} hat keine Zeilen, aber andere Zeilen nennen Einträge daraus. Bitte diese Einträge im Blatt {{sheet}} ergänzen oder die Zellen leeren, die sie nennen.",
      "excelAmbiguousNames": "Mehrere Zeilen haben denselben Namen, auf den eine andere Zelle verweist ({{rows}}). Bitte die Namen eindeutig machen.",
      "excelUnresolvedReferences": "Diese Zeilen nennen eine Abteilung oder Stelle, die in der Datei fehlt ({{rows}}). Bitte im Blatt {{departmentsSheet}} oder {{rolesSheet}} ergänzen oder den Namen korrigieren.",
      "excelParentCycle": "Diese Abteilungen sind sich gegenseitig übergeordnet ({{rows}}). Bitte die übergeordneten Abteilungen korrigieren.",
      "excelUnknownEmails": "Diese Zeilen nennen eine E-Mail-Adresse, die zu keiner Person gehört ({{rows}}). Bitte die Person im Blatt {{peopleSheet}} ergänzen oder die Adresse korrigieren.",
      "excelUnlistedLeads": "Diese Zeilen nennen eine Person, die die Datei entfernt ({{rows}}). Bitte die Person im Blatt {{peopleSheet}} ergänzen oder eine andere Person nennen.",
      "excelNoPeople": "Das Blatt {{sheet}} enthält keine Personen.",
      "personioNotLinked": "Personio ist nicht verbunden.",
      "personioCredentialsRejected": "Personio hat die Zugangsdaten abgelehnt. Bitte Client-ID und Client-Secret prüfen.",
      "personioReadFailed": "Personio konnte nicht vollständig gelesen werden. Es wurde nichts geändert. Bitte später erneut versuchen.",
      "personioCredentialsUnreadable": "Die gespeicherten Personio-Zugangsdaten sind nicht mehr lesbar. Bitte verbinde Personio neu."
    },
    "capacity": {
      "manualNotApplicable": "Dieser Schritt ist einem System oder einem externen Kontakt zugewiesen und erfasst daher keine Kapazität."
    },
    "survey": {
      "notFound": "Umfrage nicht gefunden",
      "notApplicable": "Diese Umfrage stellt dir keine Frage",
      "variantCheckNotApplicable": "Diese Frage steht dir nicht offen",
      "variantDescriptionRequired": "Bitte beschreibe, was du anders machst",
      "variantVerdictRequired": "Bitte beantworte zuerst, ob du diesen Schritt genau so machst",
      "variantAlreadyAnswered": "Diese Umfrage wurde inzwischen beantwortet. Bitte lade die Seite neu.",
      "alreadyDismissed": "Diese Umfrage wurde bereits abgelehnt"
    },
    "entitySuggestion": {
      "notFound": "Vorschlag nicht gefunden",
      "invalidTransition": "Dieser Vorschlag kann nicht in diesen Status wechseln",
      "missingAdminField": "Ein nur für Administratoren bestimmtes Feld ist erforderlich"
    },
    "insufficientPermissions": "Unzureichende Berechtigungen",
    "totp": {
      "unavailable": "Die Zwei-Faktor-Authentifizierung ist für Ihr Konto nicht verfügbar.",
      "invalidCode": "Der Code ist ungültig. Bitte versuchen Sie es erneut.",
      "alreadyConfigured": "Die Zwei-Faktor-Authentifizierung ist bereits eingerichtet. Entfernen Sie sie zuerst, um sie neu einzurichten.",
      "registrationNotFound": "Keine ausstehende 2FA-Einrichtung gefunden. Bitte starten Sie die Einrichtung erneut."
    },
    "passkeys": {
      "unavailable": "Passkeys sind für Ihr Konto nicht verfügbar.",
      "lastAuthMethod": "Dieser Passkey ist deine letzte Anmeldemethode und kann nicht entfernt werden. Richte zuerst ein Passwort oder einen weiteren Passkey ein."
    },
    "homeOrgMove": {
      "noIdentity": "Diese Person hat keine Anmelde-Identität, die verschoben werden kann.",
      "targetNotSsoEnabled": "Die ausgewählte Organisation ist nicht SSO-fähig.",
      "noMembershipInTarget": "Diese Person ist kein aktives Mitglied der ausgewählten Organisation.",
      "staffRefused": "Staff-Konten können nicht in eine andere Heimatorganisation verschoben werden.",
      "identityDisabled": "Die Anmelde-Identität dieser Person ist deaktiviert und kann nicht verschoben werden.",
      "conflict": "Die Anmelde-Identität dieser Person hat sich während der Verschiebung geändert. Bitte lade die Seite neu und versuche es erneut.",
      "emailConflict": "Ein Anmeldekonto mit der E-Mail {{email}} gehört bereits einer anderen Person.",
      "deadEmailSyncItem": "Für diese Person liegt ein festgefahrener E-Mail-Änderungseintrag in der Synchronisierungswarteschlange. Bitte reaktiviere oder lösche ihn, bevor die Heimatorganisation verschoben wird."
    },
    "signInReset": {
      "notPermitted": "Nur ein Systemadministrator der Heimatorganisation dieser Person kann ihre Anmeldung zurücksetzen.",
      "self": "Du kannst deine eigene Anmeldung nicht zurücksetzen.",
      "userNotActive": "Nur die Anmeldung aktiver Mitglieder kann zurückgesetzt werden. Bei einer offenen Einladung sende stattdessen die Einladung erneut.",
      "noHomeOrg": "Die Heimatorganisation dieser Person ist unbekannt, daher kann ihre Anmeldung hier nicht zurückgesetzt werden.",
      "homeOrgDeleted": "Die Heimatorganisation dieser Person wurde gelöscht. Weise zuerst eine neue Heimatorganisation zu, bevor du die Anmeldung zurücksetzt.",
      "ssoEnforced": "Diese Person meldet sich über das Single Sign-on ihrer Organisation an – die Anmeldung wird dort verwaltet.",
      "conflict": "Die Anmeldung dieser Person hat sich während des Zurücksetzens geändert. Bitte lade die Seite neu und versuche es erneut.",
      "identityDisabled": "Die Anmeldung dieser Person ist deaktiviert und kann daher nicht zurückgesetzt werden. Stelle zuerst ihren Zugang wieder her.",
      "emailChangeUnsettled": "Eine E-Mail-Änderung für diese Adresse ist noch nicht im Anmeldekonto angekommen, daher kann die Anmeldung gerade nicht zurückgesetzt werden. Bitte versuche es in einigen Minuten erneut; besteht das Problem weiter, wende dich an den Support."
    },
    "stepTemplate": {
      "notFound": "Schrittvorlage nicht gefunden",
      "invalidSelection": "Die Auswahl enthält Elemente, die nicht zu diesem Entwurf gehören",
      "corrupt": "Die Schrittvorlage ist fehlerhaft und kann nicht eingefügt werden"
    },
    "app": {
      "notFoundInRegistry": "Diese App ist nicht verfügbar.",
      "notAvailableForTenant": "Diese App ist für deinen Arbeitsbereich nicht verfügbar. Bitte deinen Administrator um Hilfe.",
      "notUnlocked": "Diese App ist für diesen Mandanten nicht freigeschaltet.",
      "notInstalled": "Diese App ist für deinen Arbeitsbereich nicht installiert.",
      "notActive": "Diese App ist für deinen Arbeitsbereich nicht aktiv.",
      "fileNotFound": "Datei nicht gefunden",
      "fileTypeUnsupported": "Nicht unterstützter Dateityp: {{mimeType}}",
      "fileTooLarge": "Die Datei ist größer als das Limit von {{maxSizeBytes}} Byte.",
      "fileExpired": "Diese Datei ist nicht mehr verfügbar – die Aufbewahrungsfrist ist abgelaufen."
    },
    "appChat": {
      "sessionNotFound": "Diese Chat-Sitzung existiert nicht mehr."
    },
    "omniscient": {
      "exportNotFound": "Export nicht gefunden"
    },
    "transcription": {
      "audioFormatUnsupported": "Nicht unterstütztes Audioformat: {{mimeType}}"
    },
    "chat": {
      "messageNotFound": "Diese Nachricht existiert nicht mehr."
    },
    "account": {
      "parentCycle": "Dieses Konto kann sich nicht selbst untergeordnet werden.",
      "parentTooDeep": "Die Gruppe ist zu tief verschachtelt.",
      "companyAlreadyAssigned": "Diese HubSpot-Company ist bereits einem anderen Konto zugeordnet.",
      "partnerCompanyLocked": "Dieses Konto führt einen Partner-Arbeitsbereich ({{tenantName}}). Seine HubSpot-Company darf nur ändern, wer Arbeitsbereiche verwaltet.",
      "notFound": "Konto nicht gefunden."
    },
    "hubspot": {
      "companyNotFound": "Keine HubSpot-Company mit dieser Kennung."
    },
    "superAdmin": {
      "lastAdmin": "Danach gäbe es niemanden mehr, der sich als Plattform-Administration anmelden kann — und nur sie kann Rollen vergeben."
    }
  }
}
